import BaseService from "../../services/BaseService";

class TagService extends BaseService {};

export default new TagService('health_backend', 'tags');